import { ChangeDetectionStrategy, Component, Inject, Input, OnChanges, OnInit } from '@angular/core';

import { IPlayerChapter } from './chapters/IPlayerChapter';

import { VBRICK_PLAYER_HOST } from '../../VbPlayerHostToken';

@Component({
	selector: 'vg-scrub-bar-preview',
	changeDetection: ChangeDetectionStrategy.OnPush,
	template: `
		@if (!chapter) {
			<div
				class="thumbnail"
				vbImageLoad
				[bgImageUri]="backgroundUri"
				[style.background-size]="backgroundSize"
				[style.background-position]="backgroundPosition"
				[style.width]="width"
				[style.height]="height"
			></div>
			<div class="timeDisplay">
				{{ timeSecs * 1000 | vbPlayerTime }}
			</div>
		} @else {
			<div
				class="thumbnail"
				vbImageLoad
				[bgImageUri]="backgroundUri"
				[style.background-size]="backgroundSize"
				[style.width]="width"
				[style.height]="height"
			></div>
			<div class="chapterTitleDisplay">
				{{ chapter.title }}
			</div>
			<div class="timeDisplay">
				{{ timeSecs * 1000 | vbPlayerTime }}
			</div>
		}
	`,
	standalone: false,
	styleUrls: ['./VgScrubBarPreview.Component.ng.less']
})
export class VgScrubBarPreviewComponent implements OnChanges {
	@Input() public timeSecs: number;
	@Input() public chapter: IPlayerChapter;

	public backgroundUri: string;
	public backgroundSize: string;
	public backgroundPosition: string;
	public width: string;
	public height: string;

	constructor(
		@Inject(VBRICK_PLAYER_HOST)
		public vbrickPlayer: any
	) { }

	public ngOnChanges(): void {
		if (this.timeSecs) {
			this.updateBackgroundPosition();
		}

		if (this.chapter) {
			this.backgroundUri = `${this.chapter.url}`;
			this.backgroundSize = `${this.vbrickPlayer.chapterHelper.chapterPreviewWidth}px ${this.vbrickPlayer.chapterHelper.chapterPreviewHeight}px`;
			this.width = `${this.vbrickPlayer.chapterHelper.chapterPreviewWidth}px`;
			this.height = `${this.vbrickPlayer.chapterHelper.chapterPreviewHeight}px`;
		} else {
			this.backgroundUri = `${this.vbrickPlayer.thumbnailCfg.pageUrls[0]}`;
			this.backgroundSize = `${this.vbrickPlayer.thumbnailCfg.pageResolution.width}px ${this.vbrickPlayer.thumbnailCfg.pageResolution.height}px`;
			this.width = `${this.vbrickPlayer.thumbnailCfg.tileResolution.width}px`;
			this.height = `${this.vbrickPlayer.thumbnailCfg.tileResolution.height}px`;
		}
	}

	public updateBackgroundPosition(): void {
		const frameNumber = Math.floor(this.timeSecs / (this.vbrickPlayer.thumbnailCfg.thumbnailDuration / 1000));
		const x = (frameNumber % this.vbrickPlayer.thumbnailCfg.thumbnailTiling.horizontal) * this.vbrickPlayer.thumbnailCfg.tileResolution.width;
		const y = Math.floor(frameNumber / this.vbrickPlayer.thumbnailCfg.thumbnailTiling.vertical) * this.vbrickPlayer.thumbnailCfg.tileResolution.height;
		this.backgroundPosition = `${-x}px ${-y}px`;
	}

}
